// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styling for the AI Art tool page */

#ai-main {
    padding: 30px;
}

#ai-main > * {
    height: 100%;
}

#generator-panel {
    height: 100%;
}

#generator-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

#generator-header > div {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
}

#generation-area {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    height: 100%;
}

#generated-image {
    max-height: 256px;

    margin: 15px;
}

#adv-image {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    /* gap: 15px; */

    /* width: 100%; */
}

#advanced-options {
    display: flex;
    flex-direction: column;
}

#bias-toggle, #advopt-toggle {
    display: flex;
    flex-direction: row;
}

.style-card {
    margin: 15px;
    padding: 10px;

    display: flex;
    flex-direction: column;
    gap: 10px;
}

#ai-image-area {
    display: flex;
    flex-direction: column;
    align-items: center;
}

#status-popup {
    display: none;
    padding: 10px;
    color: white;
    position: fixed;
}

#save-ai-img-btn.locked, #GenerateButton.locked {
    background-color: #888888 !important;
    background-size: contain;
    border: none;
    color: white !important;
}

@media (orientation: portrait) {
    #ai-panelarea {
      display: flex;
      flex-direction: column;
      gap: 30px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/css/AIArtPage.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;;IAEnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;;IAEjB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;;IAEf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;;IAEb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,wBAAwB;IACxB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI;MACE,aAAa;MACb,sBAAsB;MACtB,SAAS;IACX;EACF","sourcesContent":["/* Styling for the AI Art tool page */\n\n#ai-main {\n    padding: 30px;\n}\n\n#ai-main > * {\n    height: 100%;\n}\n\n#generator-panel {\n    height: 100%;\n}\n\n#generator-header {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n#generator-header > div {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    align-items: center;\n}\n\n#generation-area {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n\n    height: 100%;\n}\n\n#generated-image {\n    max-height: 256px;\n\n    margin: 15px;\n}\n\n#adv-image {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    /* gap: 15px; */\n\n    /* width: 100%; */\n}\n\n#advanced-options {\n    display: flex;\n    flex-direction: column;\n}\n\n#bias-toggle, #advopt-toggle {\n    display: flex;\n    flex-direction: row;\n}\n\n.style-card {\n    margin: 15px;\n    padding: 10px;\n\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n#ai-image-area {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n#status-popup {\n    display: none;\n    padding: 10px;\n    color: white;\n    position: fixed;\n}\n\n#save-ai-img-btn.locked, #GenerateButton.locked {\n    background-color: #888888 !important;\n    background-size: contain;\n    border: none;\n    color: white !important;\n}\n\n@media (orientation: portrait) {\n    #ai-panelarea {\n      display: flex;\n      flex-direction: column;\n      gap: 30px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
